import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { MdLanguage, MdOutlineAssignment } from 'react-icons/md';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { a11yProps, CustomTabPanel } from 'components/Common/CustomTabPanel';
import BusinessKnowledgeIcon from 'assets/icons/BusinessKnowledgeIcon';
import QAIcon from 'assets/icons/QAIcon';
import QuestionAnswer from './components/QuestionAnswer';
import BusinessKnowledge from './components/BusinessKnowledge';
import AgentDatasets from './components/AgentDatasets';
import { useGetAgent } from '@/apis/business/agent/hook';

export default function Knowledge() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: agent } = useGetAgent();

  const getTabIndexFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const tabIndex = params.get('tab');
    return tabIndex ? Number(tabIndex) : 0;
  };

  const [value, setValue] = useState<number>(getTabIndexFromUrl);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate({
      pathname: location.pathname,
      search: `?tab=${newValue}`
    });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <Box
        bgcolor='background.paper'
        mb={3}
        py={0.5}
        px={0.5}
        borderRadius={2}
        border='1px solid rgba(240, 239, 239, 0.9)'
      >
        <Box sx={{ overflowX: { xs: 'auto', lg: 'visible' } }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='knowledge tabs'
            variant='fullWidth'
            sx={{ minWidth: { xs: 480, lg: 'auto' } }}
          >
            <Tab
              label={
                <Box display='flex' gap={1} alignItems='center'>
                  <QAIcon />
                  Q&A
                </Box>
              }
              {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 0)}
            />
            <Tab
              label={
                <Box display='flex' gap={1} alignItems='center'>
                  <MdLanguage style={{ fontSize: 20 }} />
                  Web
                </Box>
              }
              {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 1)}
            />
            <Tab
              label={
                <Box display='flex' gap={1} alignItems='center'>
                  <MdOutlineAssignment style={{ fontSize: 20 }} />
                  Documents
                </Box>
              }
              {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 2)}
            />
            <Tab
              label={
                <Box display='flex' gap={1} alignItems='center'>
                  <BusinessKnowledgeIcon />
                  Business Knowledge
                </Box>
              }
              {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 3)}
            />
          </Tabs>
        </Box>
      </Box>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={0}>
        <QuestionAnswer knowledgeBaseId={agent?.knowledgebasis_ids?.[0]} />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={1}>
        <AgentDatasets type='website' knowledgeBaseId={agent?.knowledgebasis_ids?.[0]} />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={2}>
        <AgentDatasets type='document' knowledgeBaseId={agent?.knowledgebasis_ids?.[0]} />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={3}>
        <BusinessKnowledge />
      </CustomTabPanel>

      <Outlet />
    </Box>
  );
}
